import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BannerApartment, BreadcumbApartment, MenuApartment } from '../common';
import { getOverview } from '../detailApartment.api';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { getQueryString } from '../../../utils/params';
import { useParams } from 'react-router-dom';
function OverviewComponent() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { language } = useParams();
  const [videoUrl, setVideoUrl] = useState('');
  const [overview, setOverviewInfo] = useState();
  const { id } = useParams();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    showLoader();

    getOverview(getQueryString({ language, projectId: id })).then(res => {
      if (res) {
        setOverviewInfo(res);
        const _url = res?.videoUrl?.replace('watch?v=', 'embed/');
        setVideoUrl(_url);
      }
      hideLoader();
    });
    //eslint-disable-next-line
  }, [id]);

  function createMarkup() {
    if (overview) {
      return { __html: overview.content };
    }
  }

  const handleOverview = () => {
    if (overview) {
      return (
        <>
          <div className="title">{overview.name}</div>
          <div className="description" dangerouslySetInnerHTML={createMarkup()}></div>
        </>
      );
    }
  };

  return (
    <>
      <BreadcumbApartment />
      <BannerApartment />
      <MenuApartment />
      <div id="detailProjectOverview">
        <div className="container">
          {handleOverview()}
          {videoUrl ? (
            <div className="d-flex justify-content-center" style={{ paddingTop: '45px', paddingBottom: '70px' }}>
              <iframe
                width="100%"
                height="500px"
                src={videoUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          ):('')}
        </div>
      </div>
      {loader}
    </>
  );
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OverviewComponent);
